import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Escandallo/eliminarEscandalloSeleccion`, method: 'POST', body: values, token: token})
}